import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { concat, timer } from 'rxjs';
import { filter, first, mergeMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as appStore from '@appstore/*';
import { NotificationData } from '@models/*';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class UpdatesService {
    constructor(
        private readonly appRef: ApplicationRef,
        private readonly swUpdate: SwUpdate,
        private readonly store: Store<appStore.AppState>,
        private readonly translateService: TranslateService,
    ) {
        concat(
            this.appRef.isStable.pipe(first(stable => stable)),
            timer(0, 5 * 60 * 1000)
        ).pipe(
            tap(async () => {
                await this.swUpdate.checkForUpdate();
            })
        ).subscribe();

        this.swUpdate.versionUpdates.pipe(
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
          mergeMap(() => this.store.select(appStore.getAppInitComplete)),
            first(complete => complete),
            tap(() => {
                const notification: NotificationData = {
                    type: 'app-new-version',
                    targetId: null,
                    title: this.translateService.instant('NOTIFICATIONS.APP_NEW_VERSION_TITLE'),
                    body: this.translateService.instant('NOTIFICATIONS.APP_NEW_VERSION_BODY'),
                    button: {
                        text: this.translateService.instant('NOTIFICATIONS.APP_NEW_VERSION_BUTTON'),
                        url: null
                    }
                };

                // Sentry.withScope(scope => {
                //   scope.setTag('marker', 'device requires version update');
                //   Sentry.captureMessage('version update available', 'warning');
                // });
                this.store.dispatch(new appStore.AddNotification({ notification, duringOffline: false }));
            })
        ).subscribe();
    }
}
